/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:25:12
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 09:41:50
 */

import { Breadcrumb, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Route, Switch, useLocation } from "react-router-dom";
import { getMenuTitleNamed, } from "../../models/menuTitle";
import { AccountStation } from "../AccountStation/AccountStation";
import { FactoryMessage } from "../Factory/Factory";
import { WarningRuleMessage } from "../warningRule/warningRule";
import styles from "./system.module.css";

const { Sider, Content } = Layout;

export const SystemLayout = () => {
  const location = useLocation();

  const [selectedKey, setSelectedKey] = useState("");

  useEffect(() => {
    const paths = location.pathname.split("/");
    if (paths.length === 2) {
      setSelectedKey("factory");
    } else if (
      paths.length >= 3 &&
      [
        "factory",
        "warningrules",
        "accountStation",
      ].includes(paths[2])
    ) {
      setSelectedKey(paths[2]);
    }
  }, [location]);
  return (
    <Layout style={{ height: '100%', width: '100%' }}>
      <Sider width={240} style={{ background: '#fff' }}>
        <Menu
          theme='light'
          mode='inline'
          defaultSelectedKeys={['1']}
          selectedKeys={[selectedKey]}
          onSelect={({ key }) => setSelectedKey(key as string)}
          style={{ fontSize: '16px' }}
          className={styles.menu}
        >
          <Menu.Item key='factory'>
            <Link to='/system/factory'>卫健委(局)管理</Link>
          </Menu.Item>
          <Menu.Item key='warningrules'>
            <Link to='/system/warningrules'>预警规则</Link>
          </Menu.Item>
          <Menu.Item key='accountStation'>
            <Link to='/system/accountStation'>账号管理</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Breadcrumb style={{ position: 'relative', left: '20px', top: '10px' }}>
          <Breadcrumb.Item>系统管理</Breadcrumb.Item>
          <Breadcrumb.Item>{getMenuTitleNamed(selectedKey)}</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            margin: '20px',
            minHeight: 280,
          }}
        >
          <Switch>
            <Route exact path={['/system', '/system/factory']}>
              <FactoryMessage />
            </Route>
            <Route exact path='/system/warningrules'>
              <WarningRuleMessage />
            </Route>
            <Route exact path='/system/AccountStation'>
              <AccountStation />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </Layout>
  )
};
